import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var OrderDeleteRes;
export const OrderDeleteTodo = createAsyncThunk('OrderDelete', async (data) => {
    // console.log(data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'delete_main_List',
            data: {
                "id": data?.id,
                "vpurchase_order_code": data.vpurchase_order_code,
                "vip_address": "192.168.0.22",
                "vlogin_system_name": "DESKTOP-A4QMPR3",
                "vnarration": data.reason,
                "vcustomer_code": localStorage.getItem('vcust_plant_code')
            },
            headers: { "Content-Type": "application/json" }
        })
        return OrderDeleteRes = res.data

    } catch (error) {
        return OrderDeleteRes = error.response.data
    }
})